import get from 'lodash/get';
import * as utils from './Utils';
import * as bigCommerceUtils from './BigCommerce';
import * as easyStoreUtils from './EasyStore';
import * as shopifyUtils from './Shopify';
import * as shoplineUtils from './Shopline';
import * as shopwareUtils from './Shopware';
import * as wixUtils from './Wix';
import * as wooCommerceUtils from './WooCommerce';


export function setupCartUpdateEvent() {
  if (!window.OnVoardEventsReady) window.OnVoardEventsReady = {};
  if (window.OnVoardEventsReady['cart_update']) return;

  let platform = utils.getEcommercePlatform();
  if (platform === 'shopify') {
    shopifyUtils.setupCartUpdateEvent();
  }

  if (platform === 'bigcommerce') {
    bigCommerceUtils.setupCartUpdateEvent();
  }

  if (platform === 'easystore') {
    easyStoreUtils.setupCartUpdateEvent();
  }

  if (platform === 'shopline') {
    shoplineUtils.setupCartUpdateEvent();
  }

  if (platform === 'shopware') {
    shopwareUtils.setupCartUpdateEvent();
  }

  if (platform === 'wix') {
    wixUtils.setupCartUpdateEvent();
  }

  if (platform === 'woocommerce') {
    wooCommerceUtils.setupCartUpdateEvent();
  }

  window.OnVoardEventsReady['cart_update'] = 1;
}

export function loadCart() {
  let platform = utils.getEcommercePlatform();

  if (platform === 'shopify') {
    shopifyUtils.loadCart();
  }

  if (platform === 'bigcommerce') {
    bigCommerceUtils.loadCart();
  }

  if (platform === 'easystore') {
    easyStoreUtils.loadCart();
  }

  if (platform === 'shopline') {
    shoplineUtils.loadCart();
  }

  if (platform === 'shopware') {
    shopwareUtils.loadCart();
  }

  if (platform === 'wix') {
    wixUtils.loadCart();
  }

  if (platform === 'woocommerce') {
    wooCommerceUtils.loadCart();
  }
}

export function addToCart(productId, kwargs={}) {
  let platform = utils.getEcommercePlatform();

  if (platform === 'shopify') {
    return shopifyUtils.addToCart(productId, kwargs);
  }

  if (platform === 'bigcommerce') {
    return bigCommerceUtils.addToCart(productId, kwargs);
  }

  if (platform === 'wix') {
    return wixUtils.addToCart(productId, kwargs);
  }
}

export function formatCartResponse(response) {
  let platform = utils.getEcommercePlatform();
  let cart = null;

  if (platform === 'shopify') {
    cart = shopifyUtils.formatCartResponse(response);
  }

  if (platform === 'bigcommerce') {
    cart = bigCommerceUtils.formatCartResponse(response);
  }

  if (platform === 'easystore') {
    cart = easyStoreUtils.formatCartResponse(response);
  }

  if (platform === 'shopline') {
    cart = shoplineUtils.formatCartResponse(response);
  }

  if (platform === 'shopware') {
    cart = shopwareUtils.formatCartResponse(response);
  }

  if (platform === 'wix') {
    cart = wixUtils.formatCartResponse(response);
  }

  if (platform === 'woocommerce') {
    cart = wooCommerceUtils.formatCartResponse(response);
  }

  if (!cart) cart = response || {};
  const pageCart = window.OnVoardData && window.OnVoardData.cart ? window.OnVoardData.cart : {};
  const shippingGap = response && (response.free_shipping_gap != null ? response.free_shipping_gap : response.freeShippingGap);
  cart.free_shipping_gap = shippingGap != null
    ? shippingGap
    : (pageCart.free_shipping_gap != null ? pageCart.free_shipping_gap : pageCart.freeShippingGap);
  return cart;
}

export function formatCartItem(response) {
  let platform = utils.getEcommercePlatform();

  if (platform === 'shopify') {
    return shopifyUtils.formatCartItem(response);
  }

  if (platform === 'bigcommerce') {
    return bigCommerceUtils.formatCartItem(response);
  }

  if (platform === 'easystore') {
    return easyStoreUtils.formatCartItem(response);
  }

  if (platform === 'shopline') {
    return shoplineUtils.formatCartItem(response);
  }

  if (platform === 'shopware') {
    return shopwareUtils.formatCartItem(response);
  }

  if (platform === 'wix') {
    return wixUtils.formatCartItem(response);
  }

  if (platform === 'woocommerce') {
    return wooCommerceUtils.formatCartItem(response);
  }

  return response;
}

export function checkCartDataLoaded() {
  let cartResponse = utils.getExistingCartResponse();
  if (cartResponse) return true;
  return false;
}

export function loadInitialCartData() {
  let cartResponse = utils.getExistingCartResponse();

  if (cartResponse) {
    utils.dispatchCartUpdateEvent(cartResponse);
    return;
  }

  loadCart();
}
